import React, { useEffect } from 'react';
import './JournalAgreement.scss';
import { Form, Row, Col, Select, Divider, Typography, Spin } from 'antd';

import useAuth from '../../../hooks/useAuth';
import TreeSelectKias from '@modules/TreeSelect/TreeSelectKias';
import dayjs from 'dayjs';
import useQuotation from '../hooks/useQuotation';
import CInput from '@components/UI/input/CInput';
import CSelect from '@components/UI/select/CSelect';
import CButton from '@components/UI/button/CButton';
import CDatePicker from '@components/UI/datepicker/CDatePicker';
import { SearchOutlined } from '@ant-design/icons';

const { Option } = Select;
const { Title } = Typography;

function JournalAgreement({ setFilerProduct, setDataAfterSubmitAndClear }) {
  const auth = useAuth();

  const { colleaguesKiasList, isLoadingColleaguesKiasList, productList } =
    useQuotation();

  const [journalAgreementForm] = Form.useForm();

  const statusList = [
    { key: 'А', value: 'Аннулирован' },
    { key: 'В', value: 'Выпущен' },
    { key: 'П', value: 'Подписан' },
    { key: 'С', value: 'Оформление' },
    { key: 'Д', value: 'Прекращен страхователем' },
    { key: 'Щ', value: 'Прекращен страховщиком' },
    { key: 'Л', value: 'Изменен по доп. согл.' },
  ];

  function openCreatedAgreement(submitedFormObject) {
    undefinedValuesChangeToNullableAndSetData(submitedFormObject);
    setFilerProduct(true);
  }

  function undefinedValuesChangeToNullableAndSetData(submitedFormObject) {
    let copySubmitedFormObjectAndClearReturnString = JSON.stringify(
      submitedFormObject,
      function (key, value) {
        if (key === 'date_beg' && value !== undefined) {
          value = dayjs(value).format('DD.MM.YYYY');
        } else if (key === 'date_end' && value !== undefined) {
          value = dayjs(value).format('DD.MM.YYYY');
        }

        return typeof value === 'undefined' ? null : value;
      }
    );
    const newCopyOfSubmitedObject = JSON.parse(
      copySubmitedFormObjectAndClearReturnString
    );

    setDataAfterSubmitAndClear(newCopyOfSubmitedObject);
  }
  useEffect(() => {
    if (auth.user?.data?.user_info?.foreign_id) {
      if (!journalAgreementForm.getFieldValue('user_isn')) {
        journalAgreementForm.setFieldValue(
          'user_isn',
          auth.user?.data?.user_info?.foreign_id
        );
      }
    }
  }, [auth.user?.data?.user_info?.foreign_id]);

  return (
    <Form
      form={journalAgreementForm}
      onFinish={openCreatedAgreement}
      name="basic"
      layout="vertical"
      className="c-form"
    >
      <Row gutter={24}>
        <Col span={8} xs={24} xl={24}>
          <Title style={{ color: '#7449EF' }} level={3}>
            Поиск по фильтрам
          </Title>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={8} xs={24} xl={8}>
          <Form.Item label="Номер договора" name="id">
            <CInput placeholder="Введите номер договора" size="large" />
          </Form.Item>
        </Col>
        <Col span={8} xs={24} xl={8}>
          <Form.Item label="Вид договора" initialValue={220603}>
            <CSelect size="large">
              <Option value={220603}>Первичная</Option>
            </CSelect>
          </Form.Item>
        </Col>
        <Col span={8} xs={24} xl={8}>
          <Form.Item name="date_beg" label="Дата начала договора">
            <CDatePicker
              format="DD.MM.YYYY"
              style={{ width: '100%' }}
              size="large"
            />
          </Form.Item>
        </Col>
        <Col span={8} xs={24} xl={8}>
          <Form.Item name="date_end" label="Дата окончания договора">
            <CDatePicker
              format={'DD.MM.YYYY'}
              style={{ width: '100%' }}
              size="large"
            />
          </Form.Item>
        </Col>
        <Col span={8} xs={24} xl={8}>
          <Form.Item label="Страховой продукт" name="product_isn">
            <CSelect
              placeholder="Выберите продукт"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option!.children as unknown as string)
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              size="large"
              allowClear
            >
              {productList?.map((product) => (
                <Option key={product.foreign_id} value={product.foreign_id}>
                  {product.full_name}
                </Option>
              ))}
            </CSelect>
          </Form.Item>
        </Col>
        <Col span={8} xs={24} xl={8}>
          <Form.Item name="status_isn" label="Статус" initialValue="С">
            <CSelect placeholder="Статус не выбран" size="large" allowClear>
              {statusList.length &&
                statusList?.map((element) => {
                  return (
                    <Option value={element.key} key={element.key}>
                      {element.value}
                    </Option>
                  );
                })}
            </CSelect>
          </Form.Item>
        </Col>
        <Col xs={24} xl={16}>
          <Spin spinning={isLoadingColleaguesKiasList}>
            <Form.Item
              name="user_isn"
              label={`Куратор`}
              rules={[
                {
                  required: true,
                  message: 'Куратор не выбран!',
                },
              ]}
            >
              <TreeSelectKias
                colleaguesKiasList={colleaguesKiasList}
                size="large"
              />
            </Form.Item>
          </Spin>
        </Col>
        <Col span={8} xs={24} xl={8}>
          <Form.Item>
            <CButton
              type="primary"
              htmlType="submit"
              block
              className="c-button_between"
              icon={<SearchOutlined />}
            >
              Поиск
            </CButton>
          </Form.Item>
        </Col>
      </Row>
      <Divider />
    </Form>
  );
}

export default JournalAgreement;
